// Core
import { Injectable } from '@angular/core';
import { lastValueFrom } from 'rxjs';
import { environment } from '../../../environments/environment';
import { NewsletterSubscription } from '../../models/newsletter-subscription.model';
import { HttpClient } from '@angular/common/http';

@Injectable({ providedIn: 'root' })

export class NewsletterSubscriptionService {
    
    constructor(private http: HttpClient) {}

    private baseURL = `${environment.apiUrl}/newsletter`;

    subscribeUserToNewsletter = async (formData: NewsletterSubscription) => {
        try {
            const url = `${this.baseURL}/subscribe`;
            const response = await lastValueFrom(this.http.post<{ success: boolean, data: NewsletterSubscription, error?: string }>(url, formData));
            if (!response.success) {
                throw new Error(`Error subscribing user to newsletter: ${response.error}`);
            }
        } catch (error) {
            console.error(`Error subscribing user to newsletter.`);
            console.error(error);
        }
    };
}
